export default __webpack_public_path__ + "img/sagoo/sagoo1_src.jpg";